import React from 'react';

const TelegramAuth = ({ botUsername }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 to-purple-900 text-white flex items-center justify-center p-4">
      <div className="bg-blue-800/50 backdrop-blur-sm rounded-3xl p-8 max-w-md w-full text-center">
        <div className="w-24 h-24 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg 
            className="w-12 h-12 text-red-400" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
            />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold mb-4">Доступ заблокирован</h1>
        
        <p className="text-gray-300 mb-8">
          Это приложение доступно только через Telegram Mini App.
          <br />
          Пожалуйста, откройте его через нашего Telegram бота.
        </p>
        
        <a 
          href={`https://t.me/${botUsername}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 px-8 py-4 rounded-xl font-bold text-lg transition transform hover:scale-105"
        >
          <div className="flex items-center gap-3">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18.717-.962 3.807-1.359 5.055-.168.528-.5.704-.82.72-.697.064-1.226-.461-1.901-.903-1.056-.693-1.653-1.124-2.678-1.8-1.185-.781-.417-1.21.258-1.91.177-.183 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.248-.024c-.106.024-1.793 1.139-5.062 3.345-.479.329-.913.489-1.302.481-.428-.009-1.252-.242-1.865-.442-.752-.244-1.349-.374-1.297-.789.027-.216.324-.437.892-.663 3.498-1.524 5.831-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635.099-.002.321.023.465.141.121.099.155.232.171.325.016.094.036.308.02.475z"/>
            </svg>
            Открыть в Telegram
          </div>
        </a>
        
        <div className="mt-6 text-sm text-gray-400">
          Ссылка: <span className="text-blue-300">https://t.me/{botUsername}</span>
        </div>
      </div>
    </div>
  );
};

export default TelegramAuth;